import React from "react";
import { Box, Heading, Text, Stack } from "@chakra-ui/react";

const PrivacyPolicy: React.FC = () => {
  return (
    <Box>
      <Stack gap={6}>
        <Heading as="h2" size="lg" color="gray.800" mb={4}>
          Cashquin Website and Payment Services Privacy Policy
        </Heading>

        <Text color="gray.600" lineHeight="1.6">
          This Privacy Policy describes how we handle your information in
          relation to online payment transactions performed through our website
          and Cashquin services.
        </Text>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Information We Collect
          </Heading>
          <Stack gap={2}>
            <Text color="gray.600" lineHeight="1.6">
              • Basic profile details (name, email, mobile) to process your
              payments and send notifications.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • Transaction details (amount, biller, time, reference IDs) to
              complete Cashquin transactions.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • Device, browser and network information for fraud prevention and
              security logs.
            </Text>
          </Stack>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Card and Bank Data Security
          </Heading>
          <Text color="gray.600" lineHeight="1.6">
            We do not store your full card data on our servers. Card, UPI, and
            net-banking credentials are processed by our PCI-DSS compliant
            payment partners and banks. We may store masked references and
            transaction tokens strictly for reconciliation and support.
          </Text>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Use of Information
          </Heading>
          <Stack gap={2}>
            <Text color="gray.600" lineHeight="1.6">
              • To process payments and provide Cashquin services.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • To comply with legal, audit and regulatory requirements.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • To detect, prevent, and investigate fraud or misuse.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • To provide customer support and service notifications.
            </Text>
          </Stack>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Sharing of Information
          </Heading>
          <Text color="gray.600" lineHeight="1.6">
            We may share necessary details with billers, banks, payment
            gateways, Cashquin ecosystem entities and regulators as required to
            complete your transaction and meet compliance obligations. We do not
            sell your personal data.
          </Text>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Data Security
          </Heading>
          <Text color="gray.600" lineHeight="1.6">
            We implement industry-standard security controls and encryption.
            However, no method of transmission over the Internet is 100% secure.
            Please use strong passwords and do not share OTPs.
          </Text>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Your Rights and Choices
          </Heading>
          <Text color="gray.600" lineHeight="1.6">
            You may contact us to update or correct your basic information where
            permitted. Certain data must be retained for statutory and dispute
            purposes.
          </Text>
        </Box>
      </Stack>
    </Box>
  );
};

export default PrivacyPolicy;
